import { render, staticRenderFns } from "./FormConfig.vue?vue&type=template&id=b5097080&scoped=true"
import script from "./FormConfig.vue?vue&type=script&lang=js"
export * from "./FormConfig.vue?vue&type=script&lang=js"
import style0 from "./FormConfig.vue?vue&type=style&index=0&id=b5097080&prod&scoped=true&lang=css"
import style1 from "./FormConfig.vue?vue&type=style&index=1&id=b5097080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5097080",
  null
  
)

export default component.exports